import { TimeInterval, PeriodReference, AlarmsFilterDTO, LogbookEntrySortOrder, DateOrder } from '../../models';
import { AlarmsTableConfigurationParameters } from './AlarmTableParameters.configuration';

export class AlarmsTableConfiguration {
    showGroup: boolean;
    showIdentifier?: boolean;
    showTag?: boolean;
    showUnit?: boolean;
    showComment?: boolean;
    showNumberOfExcursions?: boolean;
    showExcursionTime?: boolean;
    showMaxDeviation?: boolean;
    showCurrentValue?: boolean;
    showTrend?: boolean;
    dateFormat?: string;
    minPeriod: TimeInterval;
    maxPeriod: TimeInterval;
    alignedOn: PeriodReference;
    //TODO typings
    filters: AlarmsFilterDTO;
    parameters: AlarmsTableConfigurationParameters;
    referenceGroup?: string;
    beginDateTime?: string;
    endDateTime?: string;
    identifierName?: string;

    constructor() {
        this.showGroup = true;
        this.showIdentifier = true;
        this.showTag = true;
        this.showUnit = true;
        this.showComment = true;
        this.showExcursionTime = true;
        this.showMaxDeviation = true;
        this.showCurrentValue = true;
        this.showTrend = true;
        this.filters = {
            includeChildren: true,
            groupGuids: [],
            categories: [],
            groupTypes: [],
            severities: ['Information', 'Warning', 'Critical'],
            sortBy: LogbookEntrySortOrder.Date.toString(),
            dateOrder: DateOrder.Increasing.toString(),
            isBoundToGroup: false
        } as AlarmsFilterDTO,
        this.dateFormat = '';
        this.minPeriod = {} as TimeInterval;
        this.maxPeriod = {} as TimeInterval;
        this.alignedOn = 0;
        this.parameters = {} as AlarmsTableConfigurationParameters;
    }
}